import ClearIcon from "@mui/icons-material/Clear";
import SearchIcon from "@mui/icons-material/Search";
import Button from "@mui/material/Button";
import Checkbox from "@mui/material/Checkbox";
import FormControl from "@mui/material/FormControl";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import InputLabel from "@mui/material/InputLabel";
import ListSubheader from "@mui/material/ListSubheader";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import TextField from "@mui/material/TextField";
import _ from "lodash";
import React from "react";

export function StaffSelection(props) {
  const {
    formDetail,
    staffOptions,
    handlePromoterFormData,
    multiple = true,
    disabled = false,
  } = props;
  const [searchText, setSearchText] = React.useState("");
  const [filteredStaff, setFilteredStaff] = React.useState(staffOptions);
  const [showSelected, setShowSelected] = React.useState(false);
  const handleShopChange = async (event) => {
    if (_.includes(event.target.value, "ALL")) {
      if (event.target.value.length - 1 === staffOptions.length) {
        handlePromoterFormData([]);
      } else {
        handlePromoterFormData(_.map(staffOptions, (o) => o.id));
      }
    } else {
      handlePromoterFormData(event.target.value);
    }
  };
  React.useEffect(() => {
    let filtered = _.filter(staffOptions, (s) => {
      return (
        s?.staff_code?.toLowerCase()?.indexOf(searchText.toLowerCase()) > -1 ||
        s?.alias?.toLowerCase()?.indexOf(searchText.toLowerCase()) > -1
      );
    });
    if (showSelected) {
      filtered = _.filter(filtered, (f) =>
        _.includes(formDetail.promoter, f.id),
      );
    }
    setFilteredStaff(filtered);
  }, [searchText, showSelected, staffOptions, formDetail]);
  function makeItems() {
    const items = [];
    _.forEach(filteredStaff, (s) => {
      items.push(
        <MenuItem key={s.id} value={s.id}>
          <Checkbox
            checked={
              formDetail.promoter.find((promoter) => promoter === s.id) !==
              undefined
            }
          />
          {`${s.staff_code} - ${s.alias} `}
        </MenuItem>,
      );
    });
    return items;
  }
  return (
    <FormControl sx={{ width: 300 }}>
      <InputLabel id="staff-select-label">員工</InputLabel>
      <Select
        disabled={disabled}
        MenuProps={{ autoFocus: false }}
        labelId="staff-select-label"
        id="staff-select"
        value={formDetail.promoter}
        label="店鋪"
        multiple={multiple}
        fullWidth
        onChange={handleShopChange}
        renderValue={(selected) => {
          return selected.length === staffOptions.length
            ? "所有員工"
            : `已選擇${selected.length}位員工`;
        }}
        onClose={() => setSearchText("")}
      >
        <ListSubheader
          style={{
            position: "sticky",
            top: 0,
            zIndex: 1,
          }}
        >
          <TextField
            sx={{ width: 600 }}
            style={{
              backgroundColor: "white",
            }}
            autoFocus
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton edge="end" onClick={() => setSearchText("")}>
                    <ClearIcon />
                  </IconButton>
                </InputAdornment>
              ),
            }}
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            onKeyDown={(e) => {
              if (e.key !== "Escape") {
                // Prevents autoselecting item while typing (default Select behaviour)
                e.stopPropagation();
              }
            }}
          />
        </ListSubheader>
        {searchText === "" && (
          <FormControl fullWidth sx={{ mt: 1, alignItems: "center" }}>
            <Button
              onClick={() => {
                setShowSelected(!showSelected);
              }}
              variant={showSelected ? "outlined" : "contained"}
            >
              {showSelected ? "顯示所有" : "顯示已選擇"}
            </Button>
          </FormControl>
        )}
        {makeItems()}
      </Select>
    </FormControl>
  );
}
